<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        จัดการข่าว
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาข่าว" name="searchName" [(ngModel)]="search"
      (keyup)="searching()">
    <lifedi-btn lable="เพิ่มข่าว" (click)="addNews()" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <table class="table table-striped" style="width: 95%; margin: 0 auto;">
    <thead>
      <tr class="d-flex">
        <th scope="col" *ngFor="let col of column" [class]="col.style">{{col.header}}</th>
      </tr>
    </thead>

    <!-- not search -->
    <tbody *ngIf="!isSearch">
      <tr class="d-flex" *ngFor="let news of rows;" (ngModelChange)="refresh()">
        <td scope="row" class="col">{{ news[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/news/' + news[column[0].field]" target="_blank">{{ news[column[1].field] }}</a>
        </td>
        <td scope="row" class="col">{{ news[column[2].field] }}</td>

        <td *ngIf="news.ALWAYS_OPEN == 'true'" scope="row" class="col">-</td>
        <td *ngIf="news.ALWAYS_OPEN == 'false'" scope="row" class="col">{{ news[column[3].field] | date }}</td>

        <td *ngIf="news.ALWAYS_OPEN == 'true'" scope="row" class="col">-</td>
        <td *ngIf="news.ALWAYS_OPEN == 'false'" scope="row" class="col">{{ news[column[4].field] | date }}</td>
        <td scope="row" class="col">
          <mat-slide-toggle color="primary" [(ngModel)]="!news[column[5].field]" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, news)">
          </mat-slide-toggle>
        </td>
        <td scope="row" class="col">{{ news[column[6].field] }}</td>
        <td scope="row" class="col-1">
          <a (click)="edit(news)" style="cursor: pointer;">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">
          <a (click)="duplicate(news)" style="cursor: pointer;">
            <img src="../../../../assets/duplicate.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>

    <!-- search -->
    <tbody *ngIf="isSearch">
      <tr class="d-flex" *ngFor="let news of rows; let i = index" (ngModelChange)="refreshSearch()">
        <td scope="row" class="col">{{ news[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/news/' + news[column[0].field]" target="_blank">{{ news[column[1].field] }}</a>
        </td>
        <td scope="row" class="col">{{ news[column[2].field] }}</td>
        <td *ngIf="news.ALWAYS_OPEN == 'true'" scope="row" class="col">-</td>
        <td *ngIf="news.ALWAYS_OPEN == 'false'" scope="row" class="col">{{ news[column[3].field] | date }}</td>
        <td *ngIf="news.ALWAYS_OPEN == 'true'" scope="row" class="col">-</td>
        <td *ngIf="news.ALWAYS_OPEN == 'false'" scope="row" class="col">{{ news[column[4].field] | date }}</td>
        <td scope="row" class="col">
          <mat-slide-toggle color="primary" [(ngModel)]="!news[column[5].field]" [ngModelOptions]="{ standalone: true }"
            (change)="changeStatus($event, news)">
          </mat-slide-toggle>
        </td>
        <td scope="row" class="col">{{ news[column[6].field] }}</td>
        <td scope="row" class="col-1">
          <a (click)="edit(news)" style="cursor: pointer;">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">
          <a (click)="duplicate(news)" style="cursor: pointer;">
            <img src="../../../../assets/duplicate.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>
</div>
